import {
  AUTH_HEADER_MENU_ACTIONS,
  buildAuthHeaderMenuItems,
  handleAuthHeaderMenuAction,
} from '@xstudios/xapp-auth/actions/headerMenuActions'
import { useNotificationState } from '@xstudios/xapp-core/foundation'

import { disconnectQuickBooks } from '@/domains/integrations/quickbooks/services/quickBooksService'
import { disconnectWorkspace } from '@/domains/integrations/workspace/services/googleWorkspaceService'

export const APP_HEADER_MENU_ACTIONS = {
  DISCONNECT_QUICKBOOKS: 'disconnect-quickbooks',
  DISCONNECT_WORKSPACE: 'disconnect-workspace',
}

export function buildHeaderMenuItems() {
  return [
    {
      action: APP_HEADER_MENU_ACTIONS.DISCONNECT_QUICKBOOKS,
      props: {
        prependIcon: 'mdi-book-open-variant',
      },
      title: 'Disconnect QuickBooks',
      value: APP_HEADER_MENU_ACTIONS.DISCONNECT_QUICKBOOKS,
    },
    {
      action: APP_HEADER_MENU_ACTIONS.DISCONNECT_WORKSPACE,
      props: {
        prependIcon: 'mdi-google',
      },
      title: 'Disconnect Google Workspace',
      value: APP_HEADER_MENU_ACTIONS.DISCONNECT_WORKSPACE,
    },
    { type: 'divider' },
    ...buildAuthHeaderMenuItems(),
  ]
}

export async function handleHeaderMenuAction(action, context) {
  const handledByAuth = await handleAuthHeaderMenuAction(action, context)
  if (handledByAuth) {
    return
  }

  const { notify } = useNotificationState()

  switch (action) {
    case APP_HEADER_MENU_ACTIONS.DISCONNECT_QUICKBOOKS: {
      try {
        await disconnectQuickBooks()
        notify({
          color: 'success',
          text: 'Disconnected successfully.',
          title: 'QuickBooks',
        })
      } catch (error) {
        notify({
          color: 'error',
          text:
            error?.response?.data?.detail || 'Failed to disconnect QuickBooks.',
          title: 'QuickBooks',
        })
      }
      return
    }
    case APP_HEADER_MENU_ACTIONS.DISCONNECT_WORKSPACE: {
      try {
        await disconnectWorkspace()
        notify({
          color: 'success',
          text: 'Disconnected successfully.',
          title: 'Google Workspace',
        })
      } catch (error) {
        notify({
          color: 'error',
          text:
            error?.response?.data?.detail ||
            'Failed to disconnect Google Workspace.',
          title: 'Google Workspace',
        })
      }
      return
    }
    default: {
      return
    }
  }
}

export { AUTH_HEADER_MENU_ACTIONS }
